var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.showHeader
    ? _c(
        "header",
        { attrs: { id: "header" } },
        [
          _c(
            "div",
            { staticClass: "left-buttons" },
            [
              _c(
                "button",
                {
                  staticClass: "hamburger-button",
                  attrs: {
                    type: "button",
                    "aria-label": _vm.$t("globalSideMenu.ariaOpen"),
                  },
                  on: { click: _vm.onClickHamburger },
                },
                [
                  _c("img", {
                    staticClass: "hamburger-icon",
                    attrs: { src: _vm.hamburgerIcon, alt: "" },
                  }),
                  _vm.showDesktopAppNotice
                    ? _c("span", {
                        staticClass: "notice-dot",
                        attrs: { "aria-hidden": "true" },
                      })
                    : _vm._e(),
                ]
              ),
              _c("router-link", { staticClass: "logo", attrs: { to: "/" } }, [
                _c("img", {
                  staticClass: "logo-img",
                  attrs: { src: require("@/assets/img/logo.png") },
                }),
              ]),
              _c(
                "div",
                { staticClass: "links" },
                [
                  _c(
                    "router-link",
                    {
                      staticClass: "link-item",
                      class: { active: _vm.isActivePath("/home") },
                      attrs: { to: "/" },
                      nativeOn: {
                        click: function ($event) {
                          return _vm.onClickLink("ホーム")
                        },
                      },
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("header.nav.home")) + " ")]
                  ),
                  _c(
                    "router-link",
                    {
                      staticClass: "link-item",
                      class: { active: _vm.isActivePath("/nolanovel") },
                      attrs: { to: "/nolanovel" },
                      nativeOn: {
                        click: function ($event) {
                          return _vm.onClickLink("作品投稿")
                        },
                      },
                    },
                    [
                      _vm._v(
                        " " + _vm._s(_vm.$t("header.nav.novelPosting")) + " "
                      ),
                    ]
                  ),
                  _c(
                    "router-link",
                    {
                      staticClass: "link-item tutorial-agent",
                      class: { active: _vm.isActivePath("/agent") },
                      attrs: { to: "/agent" },
                      nativeOn: {
                        click: function ($event) {
                          return _vm.onClickLink("エージェント")
                        },
                      },
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("header.nav.agent")) + " ")]
                  ),
                  _c(
                    "router-link",
                    {
                      staticClass: "link-item",
                      class: { active: _vm.isActivePath("/event/contest") },
                      attrs: { to: "/event/contest" },
                      nativeOn: {
                        click: function ($event) {
                          return _vm.onClickLink("コンテスト")
                        },
                      },
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("header.nav.contest")) + " ")]
                  ),
                  _c(
                    "router-link",
                    {
                      staticClass: "link-item",
                      class: {
                        active: _vm.isActivePath("/event", "/event/contest"),
                      },
                      attrs: { to: "/event/company" },
                      nativeOn: {
                        click: function ($event) {
                          return _vm.onClickLink("商業募集")
                        },
                      },
                    },
                    [
                      _vm._v(
                        " " + _vm._s(_vm.$t("header.nav.commercial")) + " "
                      ),
                    ]
                  ),
                  _c(
                    "router-link",
                    {
                      staticClass: "link-item",
                      class: { active: _vm.isActivePath("/knowhow") },
                      attrs: { to: "/knowhow" },
                      nativeOn: {
                        click: function ($event) {
                          return _vm.onClickLink("学習")
                        },
                      },
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("header.nav.learning")) + " ")]
                  ),
                  _c(
                    "router-link",
                    {
                      staticClass: "link-item",
                      class: { active: _vm.isActivePath("/assistant-cat") },
                      attrs: { to: { name: "assistantCatHome" } },
                      nativeOn: {
                        click: function ($event) {
                          return _vm.onClickAssistantCatHome.apply(
                            null,
                            arguments
                          )
                        },
                      },
                    },
                    [
                      _vm._v(
                        " " + _vm._s(_vm.$t("header.nav.assistantCat")) + " "
                      ),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "right-buttons" },
            [
              _vm.isNolanovelOrAgentPath
                ? _c("image-icon", {
                    staticClass: "icon-item beginners-icon",
                    attrs: {
                      to: { name: "commerceDebutGuide" },
                      src: require("@/assets/img/icon/beginners-icon.webp"),
                    },
                  })
                : _vm._e(),
              _c(
                "router-link",
                {
                  staticClass: "icon-item notification-icon",
                  class: { unread: _vm.isUnread },
                  attrs: { to: "/news" },
                },
                [
                  _c("span", { staticClass: "header-icon-wrapper" }, [
                    _c("img", {
                      attrs: {
                        src: require("@/assets/icons/notification.svg"),
                        height: "18px",
                      },
                    }),
                  ]),
                ]
              ),
              _c(
                "router-link",
                {
                  staticClass: "icon-item inbox-icon",
                  class: { unread: _vm.hasUnreadInbox },
                  attrs: { to: "/inbox" },
                  nativeOn: {
                    click: function ($event) {
                      return _vm.onClickInbox.apply(null, arguments)
                    },
                  },
                },
                [
                  _c("span", { staticClass: "header-icon-wrapper" }, [
                    _c("img", {
                      attrs: {
                        src: require("@/assets/icons/inbox.svg"),
                        height: "18px",
                      },
                    }),
                  ]),
                ]
              ),
              _c(
                "router-link",
                {
                  staticClass: "icon-item mypage-icon",
                  attrs: { to: { name: "myPage" } },
                },
                [
                  _c("span", { staticClass: "header-icon-wrapper" }, [
                    _c("img", {
                      attrs: {
                        src: require("@/assets/icons/mypage.svg"),
                        height: "18px",
                      },
                    }),
                  ]),
                ]
              ),
            ],
            1
          ),
          _c("global-side-menu", {
            attrs: { "is-open": _vm.isSideMenuOpen },
            on: { close: _vm.onCloseSideMenu },
          }),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }